export interface PaymentType {
  id: string;
  key: string;
  description: string;
}
